import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GConf from '../../../AssetsM/generalConf';
import { ToWords } from 'to-words';

function FactureTemp() {
    let { FID } = useParams();
    let [articleL, setArticleL] = useState([]);
    let [totale, setTotale] = useState(0);
    // was initialized as [] but used as an object (factureData.Client, .Phone, ...) -> use {}
    let [factureData, setFactData] = useState({});
    let [loading, setLoading] = useState(true);

    const toWords = new ToWords({
        localeCode: 'fr-FR',
        converterOptions: {
            ignoreDecimal: true,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
        }
    });

    useEffect(() => {
        axios.post(`${GConf.ApiLink}/facture/select`, {
            PID: GConf.PID,
            fid: FID
        })
        .then(function (response) {
            const data = response.data[0];
            const articles = JSON.parse(data.Articles);

            setFactData(data);
            setArticleL(articles);
            setTotale(parseFloat(data.Final_Value));
            setLoading(false);
        })
        .catch(function (error) {
            // missing before: no error handling at all, silent failures on API errors
            console.error('Erreur lors du chargement de la facture:', error);
            setLoading(false);
        });
    }, [FID]); // fid was missing from the dependency array

    // Given a TTC (tax-included) price, returns the tax (TVA) amount alone.
    // Previously this function was named CalculateTVA but actually returned
    // the HT (tax-excluded) price, not the TVA amount - the name/behavior mismatched.
    const calculateTvaAmount = (prixTTC) => {
        const facteur = GConf.DefaultTva / (100 + GConf.DefaultTva);
        return (parseFloat(prixTTC) * facteur).toFixed(3);
    };

    // Given a TTC price, returns the HT (tax-excluded) price.
    const calculatePrixHT = (prixTTC) => {
        const facteur = 100 / (100 + GConf.DefaultTva);
        return (parseFloat(prixTTC) * facteur).toFixed(3);
    };

    const FactureHeader = () => {
        // Guard against invalid dates before factureData has loaded
        const formatDate = (d) =>
            d ? new Date(d).toLocaleDateString('fr-FR').split('/').reverse().join('-') : '-';

        return (
            <>
                <h2 className='text-center'>Facture  </h2>
                <div className='row'>
                    <div className='col-6'>
                        <div className='text-secondary'><b>CODE FACTURE : </b> {FID}</div>
                        <div className='text-secondary'><b>CLIENT: {factureData.Client}</b></div>
                        <div className='text-secondary'><b>TEL: {factureData.Phone}</b></div>
                        <div className='text-secondary'><b>CIN: {factureData.CIN}</b></div>
                    </div>
                    <div className='col-6'>
                        <div className='text-danger'><b>DE : </b> {formatDate(factureData.T_Date)}</div>
                        <div className='text-danger'><b>VERS : </b> {formatDate(factureData.R_Date)}</div>
                    </div>
                </div>
            </>
        );
    };

    const TotaleCard = () => {
        return (
            <>
                <div className='row'>
                    <div className='col-6'></div>
                    <div className='col-6'>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <th scope="col">Net A Payer TTC:</th>
                                    <th scope="col">
                                        {factureData.Final_Value
                                            ? parseFloat(factureData.Final_Value).toFixed(3)
                                            : '0.000'}
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    };
    // Note: TotaleCard previously re-rendered the entire article list a second
    // time (duplicating the table below) instead of just showing the total.
    // It now only shows the total row, since the detailed article table is
    // already rendered once in the main return below.

    if (loading) {
        return <div className="container mb-4">Chargement...</div>;
    }

    return (
        <>
            <div className="container mb-4">
                <FactureHeader />
                <br />
                <br />
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">No</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Qté</th>
                            <th scope="col">Prix</th>
                            <th scope="col">Retour</th>
                            <th scope="col">Reste</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {articleL.map((artData, index) => (
                            <tr key={index + 1}>
                                <th scope="row">{index + 1}</th>
                                <td>{artData.Name}</td>
                                <td>{artData.Qte}</td>
                                <td>{artData.PU}</td>
                                <td>.............</td>
                                <td>.............</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <br />
                <TotaleCard />
                Facture arrêtée au total {toWords.convert(totale)} Dinar et{' '}
                {(parseFloat(totale) % 1).toFixed(3)} millimes
                <br />
            </div>
        </>
    );
}

export default FactureTemp;
